<script lang="ts">
	//Design system components
	import { Button, Alert } from '@Shelly/shelly-design-system';
	//Services
	import { format } from 'svelte-i18n';
</script>

<Alert class="mb-s" type="danger" heading={$format('request_failed_please_try_again')} />

<Button size="m" on:click>{$format('button_get_actions')}</Button>
